import { ParsedUrlQuery } from 'querystring';

import { BundleItemWithLowestPrice } from '@storefront/app/pdp-config/printer/product-configuration/product-configuration.utils';
import { BundleItem, BundleProduct } from '@storefront/data-commerce';

export interface OptionsType {
  attribute: string;
  image: string;
  name: string;
  description?: string;
  price: number;
  products?: Array<OptionsType>;
  sku: string;
  uid: string;
  stock: 'IN_STOCK' | 'OUT_OF_STOCK';
  selected: Array<OptionsType>;
}

export const CORE_OFFER_TYPE_LABEL_LIST = ['printer', 'pc'];

export interface SelectionType extends Array<OptionsType> {
  selected?: Array<OptionsType>;
  products?: BundleProduct;
}

export interface InitialComplexOptionsType {
  options: Array<OptionsType>;
  attributeWithUid: string;
  query: ParsedUrlQuery;
}

export type TotalStepType = {
  coreOfferTotalSteps: number;
  simpleTotalSteps: number;
};

export type OptionsWithSteps = {
  visibleSimpleOptions: Array<BundleItemWithLowestPrice>;
  coreOffer: Array<BundleItemWithLowestPrice>;
  steps: TotalStepType;
  notRequiredOptions: Array<BundleItemWithLowestPrice>;
  hiddenOptions: Array<BundleItem>;
};

export type SimpleSelectedOption = {
  bundleItemUid: string;
  BundleItemOptionUid: string;
};

export type IndexImageUrl = {
  url: string;
  coreOffer: boolean;
  smallImage: string;
};

export enum HpPlanOption {
  available = 'available',
  upgradeOnly = 'upgrade-only',
  unavailable = 'unavailable',
}

type TimeInfo = {
  apply?: string;
  fee: {
    value: string;
    sku: string;
  };
};

export interface ProductOptions {
  [key: string]: string;
}

export interface ProductConfiguration {
  [sku: string]: ProductOptions | string;
}

export type GeneralCancellation = [
  { '_-30D': TimeInfo },
  { '31D-12M': TimeInfo },
  { '13M-24M': TimeInfo }
];

export type TwoYearsCancellation = [
  ...GeneralCancellation,
  { '25M-_': TimeInfo }
];

export type ThreeYearsCancellation = [
  ...GeneralCancellation,
  { '25M-36M': TimeInfo },
  { '37M-_': TimeInfo }
];

export interface Cancel {
  name: string;
  cancellation: TwoYearsCancellation | ThreeYearsCancellation;
  currency?: string;
  is_dynamic?: boolean;
}

export enum BundleProductItemType {
  CORE_OFFER = 'Core Offer',
  INSTANT_INK = 'Instant Ink',
  INSTANT_PAPER = 'Instant Paper',
}
